import AOP from '@utilities/aop';
import CatchErrorAspect from '@infrastructure/axios/aspects/catch-errors';

export default abstract class AbstractModuleFactory {
  public static ENABLE_CUSTOM_CATCH: boolean = true;

  protected instances: Record<string, any> = {};

  protected getInstance(key: string): Nullable<any> {
    return this.instances[key];
  }

  protected cacheInstance<T>(key: string, instance: T): T {
    if (key in this.instances) {
      throw new Error('KEY FOR MODULE IS ALREADY DEFINED');
    }
    this.instances[key] = instance;
    return instance;
  }

  protected ensureInstance<T extends object>(key: string, lazyFactory: () => T): T {
    const cachedInstance = this.getInstance(key);
    if (cachedInstance) return this.inspect(cachedInstance);
    const freshInstance = lazyFactory();
    const freshCachedInstance = this.cacheInstance(key, freshInstance);
    return this.inspect(freshCachedInstance);
  }

  protected ensureInstanceWithoutErrorHandler<T extends object>(key: string, lazyFactory: () => T): T {
    const cachedInstance = this.getInstance(key);
    if (cachedInstance) return cachedInstance;
    const freshInstance = lazyFactory();
    return this.cacheInstance(key, freshInstance);
  }

  private inspect<T extends object>(instance: T): T {
    if (!AbstractModuleFactory.ENABLE_CUSTOM_CATCH) return instance;
    return AOP.add(instance, new CatchErrorAspect());
  }

  public clearInstances(): void {
    this.instances = {};
  }
}
